import React from 'react'
import { withRouter } from 'react-router'
import { Col, Typography, Form, Input, Button, TreeSelect } from 'antd'
import GWASEchart from './GWASEchart'
import MultiTraitLocuszoom from './MultiTraitLocuszoom'
import { InfoCircleOutlined } from '@ant-design/icons'
import { reqGWASdefaultConf, reqGWAStraitData, reqBestRegion } from '../../../api'
import gwasviz_multi_trait_conf from './conf/gwasviz_multi_trait_conf'

const { Paragraph } = Typography

class GWASMultiTrait extends React.Component { 
    state = {
        species: gwasviz_multi_trait_conf.species,
        //默认species的表型树形数据
        traitData: [],
        // 默认表型及默认展示区间
        query_trait: gwasviz_multi_trait_conf.query_trait,
        query_chr: gwasviz_multi_trait_conf.query_chr,
        query_loc_start: gwasviz_multi_trait_conf.query_loc_start,
        query_loc_end: gwasviz_multi_trait_conf.query_loc_end,
        // 默认species对应的染色体配置
        chr_list: [],
        chr_length: [],
        chr_color: [],
        // region用户输入默认值
        region: gwasviz_multi_trait_conf.region
    }

    formRef = React.createRef()

    // 将此方法传递给子组件echarts，当点击echarts时，更新该组件的state，以达到更新locuszoom图的效果
    stateHandler = (custom_state) => {
        this.setState(custom_state)
    }

    onTreeSelectChange = (value, label, extra) => {
        this.formRef.current.setFieldsValue({ region: '' })
    }

    // 根据用户选择表型和输入region值，更新Locuszoom图
    onFinish = async (values) => {
        const trait = values.trait
        const species = this.state.species
        let query_region = values.region
        if (!query_region) {
            const res = await reqBestRegion(species, trait)
            if (res.code === 0){
                query_region = res.data
            }
        }
        const query_chr = query_region.substr(0, query_region.indexOf(':'))
        const query_loc_start = query_region.substr(query_region.indexOf(':')+1, (query_region.indexOf('-') - query_region.indexOf(':') -1))
        const query_loc_end = query_region.substr(query_region.indexOf('-')+1)

        this.formRef.current.setFieldsValue({ region: query_region })
        this.setState({
            query_trait: trait,
            query_chr: query_chr,
            query_loc_start: query_loc_start,
            query_loc_end: query_loc_end,
            region: query_region
        })
    }

    async componentDidMount() {
        const species =  this.props.match.params.species
        // 获取该species对应的表型树形数据
        let traitData = []
        const traitDataResult = await reqGWAStraitData(species)
        if (traitDataResult.code === 0) {
            traitData = traitDataResult.data
        }
        
        // 获取该speceis对应的GWAS默认配置数据
        let conf = ''
        const conResult = await reqGWASdefaultConf('multi_trait', species)
        if (conResult.code === 0) {
            conf = conResult.data
            let query_trait = conf.default_trait
            let query_chr = conf.default_chr
            let query_loc_start = conf.default_loc_start
            let query_loc_end = conf.default_loc_end

            //解析该species对应的染色体配置数据，包括染色体名称，每个染色体长度，每个染色体在echarts图中展示的颜色等
            let chr_list = conf.ref_chr_conf.chr_list
            let chr_length = conf.ref_chr_conf.chr_length
            let chr_color = conf.ref_chr_conf.chr_color
            
            this.formRef.current.setFieldsValue({ trait: query_trait, region: `${query_chr}:${query_loc_start}-${query_loc_end}` })
            
            this.setState({ 
                species: species,
                traitData: traitData,
                query_trait: query_trait,
                query_chr: query_chr,
                query_loc_start: query_loc_start,
                query_loc_end: query_loc_end,
                chr_list: chr_list,
                chr_length: chr_length,
                chr_color: chr_color,
                region: `${query_chr}:${query_loc_start}-${query_loc_end}`
            })
        }
    }

    render() {
        const { species, traitData, query_trait, query_chr, query_loc_start, query_loc_end, chr_list, chr_length } = this.state

        return (
            <React.Fragment>
                <Paragraph className="gwas-desc">
                    <Paragraph>Browse GWAS locus for single trait within given region. If not specified, the region with the most significant P-value was displayed. The scatter plot region can be easily changed by input a new region and 'SEARCH' or click on a BIN in the navigational Manhattan Plot panel. You could also search the GWAS data through our GWAS Table browser.</Paragraph>
                    <Paragraph><b>Navigational Manhattan Plot</b></Paragraph>
                    <Paragraph>This panel shows the most significant P-value (Y-axis) between the selected trait and the genetic variants within 500Kb sliding window of the genome (X-axis). You can navigate to your interested region by zoom and drag. Click on the region will generat a gray vertical indicator, and draw 'Detailed Scatter Plot' of this region below.</Paragraph>
                    <Paragraph><b>Detailed Scatter Plot</b></Paragraph>
                    <Paragraph>This panel shows the detailed plot of the variants and the genes within a certain region. Currently, only variants with -Log10(P-value) greater than 5 were displayed. The dots were colored by LD r2 value with the 'ref-variant' ( If not specified, the variant with the most significant P-value was set as the default ref-variant. ). The gene information tooltip provides interfaces for connecting with the gene detailed information, genome browser and eQTL signals. Please notice that the min and max plot regions of the scatter plot are 20 Kb and 1 Mb, respectively. If your input region was smaller than 20 Kb (or larger than 1Mb), the flanking 20 Kb (or 1 Mb) of the middle position was plotted.</Paragraph>
                </Paragraph>
                <Form className="gwas-query-form" ref={this.formRef} layout="inline" onFinish={this.onFinish}>
                    <Col span={6}>
                        <Form.Item name="trait" label="Trait"
                            rules={[
                                { 
                                    type: 'array',
                                    required: true,
                                    max: 5
                                }
                            ]}
                            tooltip={{title: 'Limit up to 5 traits.', icon: <InfoCircleOutlined />}}
                        >
                            <TreeSelect
                                style={{ width: '100%' }}
                                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                treeCheckable= {true}
                                treeData={traitData}
                                placeholder="Please select trait"
                                onChange={this.onTreeSelectChange}
                                showSearch
                            />
                        </Form.Item>
                    </Col>
                    <Col span={6} push={1}>
                        <Form.Item name="region" label="Region"
                            rules={[
                                { type: 'string' },
                                { 
                                    pattern: /\b[\w.-]+\:[0-9]+\-[0-9]+\b/gi, 
                                    message: 'Invalid region format.'
                                },
                                { max: 128 },
                                {
                                    validator: (_, value) => {
                                        if (value) {
                                            const query_chr = value.substr(0, value.indexOf(':'))
                                            const query_loc_start = parseInt(value.substr(value.indexOf(':')+1, (value.indexOf('-') - value.indexOf(':') -1)))
                                            const query_loc_end = parseInt(value.substr(value.indexOf('-')+1))
                                            const chr_index = chr_list.findIndex((n) => n == query_chr)
                                            if (!chr_list.includes(query_chr) || query_loc_start >= chr_length[chr_index] || query_loc_end < query_loc_start) {
                                                return Promise.reject(new Error('Incorrect input of Region.'))
                                            } 
                                            if (query_loc_end - query_loc_start > 500000) {
                                                return Promise.reject(new Error(' Region should be less than 500k.'))
                                            }
                                        }

                                        return Promise.resolve()
                                    }
                                }
                            ]}
                            tooltip={{title: 'Region should be less than 500K. If not provide region, we will show the best region of the chosen trait.', icon: <InfoCircleOutlined />}}
                        >
                            <Input placeholder='eg. Chr06:129500000-130000000' value={this.state.region} />
                        </Form.Item>
                    </Col>
                    <Col push={1}>
                        <Form.Item>
                            <Button type="primary" htmlType="submit">Search</Button>
                        </Form.Item>
                    </Col>
                </Form>
                <GWASEchart echart_config={this.state} stateHandler={this.stateHandler} />
                <MultiTraitLocuszoom locuszoom_config={{species: species, query_trait: query_trait, query_chr: query_chr, query_loc_start: query_loc_start, query_loc_end: query_loc_end}} />
            </React.Fragment>
        )
    }
}

export default withRouter(GWASMultiTrait)